<!-- ── KPI SUMMARY CARDS ── -->
<div class="kbm-stat-grid" style="margin-bottom:20px">
  <div class="kbm-stat-card">
    <div class="kbm-stat-label">Reservations Shown</div>
    <div class="kbm-stat-value">{{filtered.length}}</div>
    <div class="kbm-stat-sub">of {{reservations.length}} total</div>
  </div>
  <div class="kbm-stat-card">
    <div class="kbm-stat-label">Total Billed</div>
    <div class="kbm-stat-value">{{fmt$(totalDue)}}</div>
    <div class="kbm-stat-sub">amount due</div>
  </div>
  <div class="kbm-stat-card">
    <div class="kbm-stat-label">Total Collected</div>
    <div class="kbm-stat-value" style="color:#059669">{{fmt$(totalPaid)}}</div>
    <div class="kbm-stat-sub">amount paid</div>
  </div>
  <div class="kbm-stat-card">
    <div class="kbm-stat-label">Balance Outstanding</div>
    <div class="kbm-stat-value" [style.color]="totalBal > 0 ? '#dc2626' : '#059669'">{{fmt$(totalBal)}}</div>
    <div class="kbm-stat-sub">remaining</div>
  </div>
</div>

<!-- ── DATA HEALTH BANNER ── -->
<div *ngIf="orphanReservationCount > 0 || showOrphansOnly" class="orphan-banner">
  <div class="orphan-banner-left">
    <span class="orphan-icon">&#9888;</span>
    <span class="orphan-text">
      <strong>Data Health:</strong>
      <ng-container *ngIf="!showOrphansOnly">
        {{orphanReservationCount}} reservation{{orphanReservationCount !== 1 ? 's' : ''}} reference deleted activities.
      </ng-container>
      <ng-container *ngIf="showOrphansOnly">
        Showing only orphaned reservations ({{filtered.length}} of {{reservations.length}}).
      </ng-container>
    </span>
  </div>
  <div class="orphan-banner-right">
    <button *ngIf="!showOrphansOnly" class="orphan-view-btn" (click)="showOrphansOnly = true">
      View
    </button>
    <button *ngIf="showOrphansOnly" class="orphan-dismiss-btn" (click)="dismissOrphanFilter()">
      Dismiss
    </button>
  </div>
</div>

<!-- ── FILTER BAR ── -->
<div class="kbm-filter-bar" style="margin-bottom:16px;flex-direction:column;align-items:stretch;gap:0">

  <!-- Row 1: search + dropdowns -->
  <div style="display:flex;align-items:center;flex-wrap:nowrap;gap:10px;overflow-x:auto">
    <input class="kbm-input" style="flex:1;min-width:0"
      [(ngModel)]="search" placeholder="Search by name, res #, unit…"/>

    <select class="kbm-select" style="width:160px;flex-shrink:0" [(ngModel)]="fProp">
      <option value="">All Properties</option>
      <option *ngFor="let p of uniqueProperties" [value]="p">{{p}}</option>
    </select>

    <select class="kbm-select" style="width:130px;flex-shrink:0" [(ngModel)]="fPay">
      <option value="">All Payment</option>
      <option value="unpaid">Unpaid</option>
      <option value="partial">Partial</option>
      <option value="paid">Paid</option>
      <option value="refunded">Refunded</option>
    </select>

    <select class="kbm-select" style="width:130px;flex-shrink:0" [(ngModel)]="fBook">
      <option value="">All Status</option>
      <option value="pending">Pending</option>
      <option value="confirmed">Confirmed</option>
      <option value="completed">Completed</option>
      <option value="cancelled">Cancelled</option>
    </select>
  </div>

  <!-- Row 2: date range + actions -->
  <div style="display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin-top:10px">
    <span style="font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:0.07em;white-space:nowrap">
      Activity Date:
    </span>
    <input class="kbm-input" type="date" [(ngModel)]="fDateFrom" style="width:150px" title="Activity date from"/>
    <span style="color:#d1d5db;font-size:12px">—</span>
    <input class="kbm-input" type="date" [(ngModel)]="fDateTo"   style="width:150px" title="Activity date to"/>

    <button *ngIf="hasFilters" class="btn-kbm-outline btn-kbm-sm" (click)="clearFilters()">Clear</button>

    <button class="btn-kbm-primary btn-kbm-sm" style="margin-left:auto;white-space:nowrap" (click)="openNew()">
      + New Activity Reservation
    </button>
  </div><!-- /row 2 -->

</div><!-- /filter bar -->

<!-- ── TABLE ── -->
<div class="kbm-table-card">
  <div *ngIf="loading" style="padding:40px;text-align:center;color:#9ca3af">Loading…</div>

  <table *ngIf="!loading" style="width:100%;border-collapse:collapse;font-size:13px">
    <thead>
      <tr style="background:#f9fafb;border-bottom:2px solid #e5e7eb">
        <th class="th-sort" (click)="sort('reservationNumber')">
          Res # <span class="sort-icon">{{sortIcon('reservationNumber')}}</span>
        </th>
        <th class="th-sort" (click)="sort('lastName')">
          Guest <span class="sort-icon">{{sortIcon('lastName')}}</span>
        </th>
        <th class="th-sort" (click)="sort('property')">
          Property / Unit <span class="sort-icon">{{sortIcon('property')}}</span>
        </th>
        <th style="padding:10px 12px;text-align:left;font-weight:600;color:#6b7280;font-size:11px;text-transform:uppercase;letter-spacing:0.06em">
          Activities
        </th>
        <th class="th-sort" (click)="sort('activityDate')">
          Activity Date <span class="sort-icon">{{sortIcon('activityDate')}}</span>
        </th>
        <th class="th-sort" (click)="sort('numGuests')" style="text-align:center">
          Guests <span class="sort-icon">{{sortIcon('numGuests')}}</span>
        </th>
        <th class="th-sort" (click)="sort('amountDue')" style="text-align:right">
          Billed <span class="sort-icon">{{sortIcon('amountDue')}}</span>
        </th>
        <th class="th-sort" (click)="sort('amountPaid')" style="text-align:right">
          Paid <span class="sort-icon">{{sortIcon('amountPaid')}}</span>
        </th>
        <th class="th-sort" (click)="sort('paymentStatus')">
          Payment <span class="sort-icon">{{sortIcon('paymentStatus')}}</span>
        </th>
        <th class="th-sort" (click)="sort('bookingStatus')">
          Status <span class="sort-icon">{{sortIcon('bookingStatus')}}</span>
        </th>
        <th style="padding:10px 12px;text-align:center;font-weight:600;color:#6b7280;font-size:11px;text-transform:uppercase;letter-spacing:0.06em">
          Actions
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of filtered"
        style="border-bottom:1px solid #f3f4f6;transition:background 0.1s"
        [style.background]="r.bookingStatus === 'cancelled' ? '#fef2f2' : '#fff'"
        (mouseenter)="$event.currentTarget.style.background = r.bookingStatus === 'cancelled' ? '#fee2e2' : '#f9fafb'"
        (mouseleave)="$event.currentTarget.style.background = r.bookingStatus === 'cancelled' ? '#fef2f2' : '#fff'">

        <!-- Res # -->
        <td style="padding:12px;font-family:monospace;font-size:12px;color:#059669;font-weight:600;white-space:nowrap">
          {{r.reservationNumber || '—'}}
        </td>

        <!-- Guest -->
        <td style="padding:12px">
          <div style="font-weight:600;color:#111827">{{r.firstName}} {{r.lastName}}</div>
          <div style="font-size:11px;color:#9ca3af">{{r.email}}</div>
        </td>

        <!-- Property / Unit -->
        <td style="padding:12px">
          <div style="font-size:12px;color:#374151;font-weight:500">{{r.property || '—'}}</div>
          <div style="font-size:11px;color:#9ca3af">{{r.unit || ''}}</div>
        </td>

        <!-- Activities -->
        <td style="padding:12px;max-width:200px">
          <div style="display:flex;flex-wrap:wrap;gap:4px">
            <ng-container *ngIf="activityNames(r.activityIds) as names">
              <span *ngFor="let name of names | slice:0:2"
                style="display:inline-block;padding:2px 7px;background:#d1fae5;color:#065f46;font-size:11px;font-weight:600;border-radius:4px;white-space:nowrap">
                {{name}}
              </span>
              <span *ngIf="names.length > 2"
                style="display:inline-block;padding:2px 7px;background:#f3f4f6;color:#6b7280;font-size:11px;font-weight:600;border-radius:4px;white-space:nowrap"
                [title]="names.slice(2).join(', ')">
                +{{names.length - 2}} more
              </span>
              <span *ngFor="let oid of orphanIds(r.activityIds)" class="orphan-id-chip" title="Activity ID {{oid}} no longer exists">
                ID:{{oid}}
              </span>
              <span *ngIf="names.length === 0 && !orphanIds(r.activityIds).length" style="color:#9ca3af;font-size:12px">—</span>
            </ng-container>
          </div>
        </td>

        <!-- Activity Date -->
        <td style="padding:12px;white-space:nowrap;color:#374151;font-size:12px">
          {{fmtDate(r.activityDate)}}
          <div *ngIf="r.preferredTime" style="font-size:11px;color:#9ca3af">{{r.preferredTime}}</div>
        </td>

        <!-- Guests -->
        <td style="padding:12px;text-align:center;color:#374151;font-weight:600">
          {{r.numGuests || 1}}
        </td>

        <!-- Billed -->
        <td style="padding:12px;text-align:right;font-weight:600;color:#1f2937;white-space:nowrap">
          {{fmt$(r.amountDue)}}
        </td>

        <!-- Paid -->
        <td style="padding:12px;text-align:right;font-weight:600;color:#059669;white-space:nowrap">
          {{fmt$(r.amountPaid)}}
        </td>

        <!-- Payment Status -->
        <td style="padding:12px">
          <span class="badge-kbm badge-{{r.paymentStatus}}">{{r.paymentStatus || 'unpaid'}}</span>
        </td>

        <!-- Booking Status -->
        <td style="padding:12px">
          <span class="badge-kbm badge-{{r.bookingStatus}}">{{r.bookingStatus || 'pending'}}</span>
        </td>

        <!-- Actions -->
        <td style="padding:12px;text-align:center;white-space:nowrap">
          <button class="btn-kbm-outline btn-kbm-sm" style="margin-right:4px" (click)="openEdit(r)"
            title="Edit reservation">
            Edit
          </button>
          <button *ngIf="r.bookingStatus !== 'cancelled'"
            class="btn-kbm-danger-outline btn-kbm-sm" (click)="cancelRow(r)"
            title="Cancel reservation">
            Cancel
          </button>
        </td>

      </tr>

      <!-- Empty state -->
      <tr *ngIf="filtered.length === 0">
        <td colspan="11" style="padding:40px;text-align:center;color:#9ca3af;font-size:13px">
          <div style="font-size:32px;margin-bottom:8px">📋</div>
          <div *ngIf="hasFilters">No activity reservations match the current filters.
            <button class="btn-kbm-outline btn-kbm-sm" style="margin-left:8px" (click)="clearFilters()">Clear Filters</button>
          </div>
          <div *ngIf="!hasFilters">No activity reservations yet.
            <button class="btn-kbm-primary btn-kbm-sm" style="margin-left:8px" (click)="openNew()">+ New Activity Reservation</button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Table footer -->
  <div *ngIf="!loading && filtered.length > 0"
    style="display:flex;align-items:center;justify-content:space-between;padding:10px 16px;border-top:1px solid #e5e7eb;background:#f9fafb;font-size:12px;color:#6b7280">
    <span>Showing <strong>{{filtered.length}}</strong> activity reservation{{filtered.length !== 1 ? 's' : ''}}</span>
    <div style="display:flex;gap:16px">
      <span>Billed: <strong style="color:#1f2937">{{fmt$(totalDue)}}</strong></span>
      <span>Collected: <strong style="color:#059669">{{fmt$(totalPaid)}}</strong></span>
      <span>Outstanding: <strong [style.color]="totalBal > 0 ? '#dc2626' : '#059669'">{{fmt$(totalBal)}}</strong></span>
    </div>
  </div>
</div>
